import { BatchLoadExperimentsData, EValidationResult } from 'business/models/Models';
import RMCheckBox from 'components/customComponents/Controls/RMCheckbox';
import RMSelect from 'components/customComponents/Controls/RMSelect';
import BatchloadExperimentReviewExpOptions from 'enums/BatchloadExperimentReviewExpOptions';
import React, { useMemo } from 'react';

type BatchLoadExperimentNameReviewProps = {
  firstCheckboxValue: BatchloadExperimentReviewExpOptions;
  secondCheckboxValue: BatchloadExperimentReviewExpOptions;
  thirdCheckboxValue: BatchloadExperimentReviewExpOptions;
  isSecondCheckboxChecked: boolean;
  isThirdCheckboxChecked: boolean;
  changeFirstCheckboxValue(e: any);
  changeSecondCheckboxValue(e: any);
  changeThirdCheckboxValue(e: any);
  secondCheckboxToggle(e: any);
  thirdCheckboxToggle(e: any);
  tableData: BatchLoadExperimentsData[];
};

const BatchLoadExperimentNameReview: React.FC<BatchLoadExperimentNameReviewProps> = ({
  firstCheckboxValue,
  secondCheckboxValue,
  thirdCheckboxValue,
  isSecondCheckboxChecked,
  isThirdCheckboxChecked,
  changeFirstCheckboxValue,
  changeSecondCheckboxValue,
  changeThirdCheckboxValue,
  secondCheckboxToggle,
  thirdCheckboxToggle,
  tableData,
}) => {
  const options = useMemo(() => {
    const reviewExpOptions = [
      { id: BatchloadExperimentReviewExpOptions.PLATE_ID, name: 'Plate ID' },
      { id: BatchloadExperimentReviewExpOptions.SCREENNAME, name: 'Screen Name' },
      { id: BatchloadExperimentReviewExpOptions.TEMPERATURE, name: 'Temperature' },
      { id: BatchloadExperimentReviewExpOptions.PLATE_BARCODE, name: 'Plate Barcode' },
      { id: BatchloadExperimentReviewExpOptions.DATE, name: 'Date' },
    ];
    if (
      tableData.some(
        (d) =>
          d.experimentNameTag?.validation.result !== EValidationResult.Invalid &&
          d.experimentNameTag.value?.trim() !== '',
      )
    ) {
      reviewExpOptions.push({
        id: BatchloadExperimentReviewExpOptions.EXP_NAME_TAG,
        name: 'Experiment Name Tag',
      });
    }
    return reviewExpOptions;
  }, [tableData]);

  return (
    <div
      id="batchloadexperimentnamereview-wrapper"
      className="flex space-between"
      style={{ paddingRight: '22px' }}
    >
      <SelectExpNameOption
        id="batchloadexperimentnamereview-firstoption"
        options={options}
        selectedVal={firstCheckboxValue}
        changeSelectedVal={changeFirstCheckboxValue}
        checkBoxValue={true}
        checkboxDisabled={true}
      />
      <SelectExpNameOption
        id="batchloadexperimentnamereview-secondoption"
        options={options}
        selectedVal={secondCheckboxValue}
        changeSelectedVal={changeSecondCheckboxValue}
        changeCheckbox={secondCheckboxToggle}
        checkBoxValue={isSecondCheckboxChecked}
      />
      <SelectExpNameOption
        id="batchloadexperimentnamereview-thirdoption"
        options={options}
        selectedVal={thirdCheckboxValue}
        checkBoxValue={isThirdCheckboxChecked}
        changeSelectedVal={changeThirdCheckboxValue}
        changeCheckbox={thirdCheckboxToggle}
      />
    </div>
  );
};

export default BatchLoadExperimentNameReview;

function ExpNameOption({ children, checkedValue, onChange, disabled = false }: any) {
  return (
    <div
      id="batchloadexperimentnamereview-expnameoption-checklist"
      className="flex flex-y-center flex-space-between"
      style={{
        flex: '1',
        marginLeft: '13px',
        fontSize: '0.6875rem',
        lineHeight: '0.8125rem',
      }}
    >
      <RMCheckBox
        style={{ width: '17.5%', height: '1.5rem' }}
        onChange={onChange}
        isChecked={checkedValue}
        isDisabled={disabled}
      />
      {children}
    </div>
  );
}

export function SelectExpNameOption({
  checkBoxValue,
  changeCheckbox = () => {},
  selectedVal,
  changeSelectedVal = () => {},
  options,
  selectDisabled = false,
  checkboxDisabled = false,
}: any) {
  return (
    <ExpNameOption
      id="batchloadexperimentnamereview-selectexpnameoption-wrapper"
      checkedValue={checkBoxValue}
      onChange={changeCheckbox}
      disabled={checkboxDisabled}
    >
      <RMSelect
        placeholder={null}
        options={options}
        onChange={changeSelectedVal}
        selectedValue={selectedVal}
        style={{
          width: '73%',
          marginLeft: '11px',
          fontSize: '0.6875rem',
          lineHeight: '0.8125rem',
          height: '2.0625rem',
        }}
        disabled={selectDisabled}
      />
    </ExpNameOption>
  );
}
